<ng-container *ngIf="formGroup" class="mb-4">
    <div [formGroup]="formGroup" class="address-form">
        <h4>{{ title ? title : 'Address Information' }}</h4>
        <div class="row mb-4" *ngIf="!formGroup.controls.addressType.disabled">
            <div class="col-lg-6">
                <app-form-select
                    label="Address Type"
                    [formControl]="formGroup.controls.addressType"
                >
                    <mat-option>Select Type</mat-option>
                    <mat-option [value]="'rental'">Rental</mat-option>
                    <mat-option [value]="'mortgage'">Mortgage</mat-option>
                    <mat-option [value]="'other'">Other</mat-option>
                </app-form-select>
            </div>

            <div class="col-lg-6">
                <ng-container *ngIf="!formGroup.controls.mortgageAmount.disabled">
                    <app-form-input label="Mortgage Amount" [formControl]="formGroup.controls.mortgageAmount"></app-form-input>
                </ng-container>

                <ng-container *ngIf="!formGroup.controls.rentalAmount.disabled">
                    <app-form-input label="Rental Amount" type="number" [formControl]="formGroup.controls.rentalAmount"></app-form-input>
                </ng-container>
            </div>
        </div>

        <div class="row mb-4">
            <div class="col">
                <app-form-input label="Unit #" [formControl]="formGroup.controls.unitNumber"></app-form-input>
            </div>

            <div class="col">
                <app-form-input label="Street Address 1" [formControl]="formGroup.controls.street1"></app-form-input>
            </div>

            <div class="col">
                <app-form-input label="Street Address 2" [formControl]="formGroup.controls.street2"></app-form-input>
            </div>
        </div>

        <div class="row mb-4">
            <div class="col">
                <app-form-input label="City" [formControl]="formGroup.controls.city"></app-form-input>
            </div>

            <div class="col">
                <app-form-input label="Province / State" [formControl]="formGroup.controls.state"></app-form-input>
            </div>

            <div class="col">
                <app-form-input label="Postal Code / Zip Code" [formControl]="formGroup.controls.zip"></app-form-input>
            </div>

            <div class="col">
                <app-form-select
                    label="Country"
                    [formControl]="formGroup.controls.country"
                >
                    <mat-option>Select Country</mat-option>
                    <mat-option [value]="'USA'">United States of America</mat-option>
                    <mat-option [value]="'Canada'">Canada</mat-option>
                </app-form-select>
            </div>
        </div>

        <div *ngIf="!formGroup.controls.startDate.disabled" class="row mb-4">
            <div class="col">
                <app-form-datepicker
                    label="Move In Date"
                    [formControl]="formGroup.controls.startDate"
                ></app-form-datepicker>
            </div>

            <div *ngIf="!formGroup.controls.endDate.disabled" class="col">
                <app-form-datepicker
                    label="Move Out Date"
                    [formControl]="formGroup.controls.endDate"
                ></app-form-datepicker>
            </div>


            <div *ngIf="!formGroup.controls.isCurrent.disabled" class="col">
                <app-form-checkbox
                    label="This is my current address"
                    [formControl]="formGroup.controls.isCurrent"
                ></app-form-checkbox>
            </div>
        </div>
    </div>
</ng-container>
